// extracted by mini-css-extract-plugin
module.exports = {"desktop-container":"Styles_desktop-container__CKCaZ","mobile-container":"Styles_mobile-container__3Pfyx"};